import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_REQUEST_APPOINTMENT_RESCHEDULE } from "../../action-types/actions";

export const requestAppointmentRescheduleReducer = createAsyncThunk(
  ACTIONS_REQUEST_APPOINTMENT_RESCHEDULE.request,
  async ({ appointmentId }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.requestAppointmentReschedule}/${appointmentId}/request-reschedule`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success(
          response?.data?.message || "Reschedule requested successfully",
        );
        return response.data;
      } else {
        toast.error(response?.data?.message || "Reschedule request failed");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while requesting reschedule";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
